import { useMutation } from "@tanstack/react-query";
import { useGrowl } from "PFApp/use_growl";
import { useTranslation } from "react-i18next";

import { removeProfileFromCalendar } from "../../../../../modules/admin/booking/services/api";
import { useBookingConfigProfileCalendarsInvalidate } from "./use_booking_config_profile_calendars_invalidate";

export const useRemoveBookingConfigProfileCalendar = () => {
  const { t } = useTranslation("bookingModule");
  const { invalidate } = useBookingConfigProfileCalendarsInvalidate();
  const growl = useGrowl();

  return useMutation(
    async (payload: { profileId: string; recordId: string }) => removeProfileFromCalendar(payload),
    {
      onSuccess: () => {
        growl({
          kind: "success",
          message: t("config.calendars.workforce.removedFromCalendar")
        });
        invalidate();
      }
    }
  );
};
